import { WorkflowsRootState } from '../ducks.types';

export const getIsFetchingFbCustomAudience = (state: WorkflowsRootState) =>
  state.workflow?.isFetchingFbCustomAudience;
export const getFbCustomAudience = (state: WorkflowsRootState) =>
  state.workflow?.fbCustomAudience || {};
export const getFbAccountIds = (state: WorkflowsRootState) =>
  Object.keys(getFbCustomAudience(state));
export const getFbCustomAudienceByAccountId = (state: WorkflowsRootState, accountId?: string) =>
  getFbCustomAudience(state)[accountId as string] ?? [];
